import THDStorageUtils, { COOKIE_STORAGE } from '@thd-olt-global/thd-storage-utils';

export const useStorefrontData = () => {
  const storefrontCookieData = THDStorageUtils.get(COOKIE_STORAGE, { key: 'THD_STOREFRONT' });

  if (!storefrontCookieData || storefrontCookieData === 'undefined') {
    return { storeFrontSVOCID: null, storeFrontUserID: null };
  }

  const storefrontPayload = storefrontCookieData.split('.')[1];

  if (!storefrontPayload) {
    return { storeFrontSVOCID: null, storeFrontUserID: null };
  }

  try {
    const decodedStorefrontPayload = Buffer.from(storefrontPayload, 'base64').toString();
    const { SVOCID } = JSON.parse(decodedStorefrontPayload);
    const storeFrontSVOCID = SVOCID;
    const storeFrontUserID = `${storeFrontSVOCID}_STOREFRONT`;
    return { storeFrontSVOCID, storeFrontUserID };
  } catch (error) {
    return { storeFrontSVOCID: null, storeFrontUserID: null };
  }
};
